import { useTranslation } from 'react-i18next'

import { InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const UnpublishedChangesChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t('Cambios sin publicar')}
      Icon={InfoIcon}
      backgroundColor={theme.colors.info.surface}
      color={theme.colors.info.onSurface}
    />
  )
}

export default UnpublishedChangesChip
